import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers, lifecycle } from "recompose";
import {concat, find, forEach, isEmpty} from "lodash";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";
import { FontIcon } from "react-md";

import TextField from "../../components/form/TextField";
import SelectField from "../../components/form/SelectField";
import * as Validation from "../../components/form/Validation";

import { setActiveForm } from "../../actions/appActions";
import { getRequestById, updateRequest } from "../../actions/requestActions";

import { currency } from "../../enums/index";

import {formatTime, daysHoursMinutesToString, humanFormatPrice} from "../../utils/index";
import {DebugElement} from "../../Atollon/debug";
import {
    TouchVerticalValue,
    TouchVerticalValueRow
} from "../../AtollonTheme/ReactElements";
import {RequestDetailInfoAttachments} from "./RequestDetailInfoAttachments";
import Translate from "../../Atollon/Translation";
import {SideBySide, TouchUploadButton} from "./RequestDetailNewComment";

function log()
{
    console.log.apply( null, concat( ['%cRequestDetailInfo', 'background:green;color:#fff'], arguments ));
}

const optionsCustomType = [
  { label: "Obecné", value: "Obecné" },
  { label: "Poptávka", value: "Poptávka" },
  { label: "Stížnost", value: "Stížnost" }
];

const optionsSeverity = [
  { label: "Nejnižší", value: "1", color:'#ffe17b' },
  { label: "Nízká", value: "3", color:'#ffc061' },
  { label: "Normální", value: "5", color:'#ffa450' },
  { label: "Vyšší", value: "7", color: '#ff843d' },
  { label: "Nejvyšší", value: "10", color: '#D90000' }
];

const optionsTax = [
  { label: "Bez daně", value: "WITHOUT_TAX" },
  { label: "Včetně daně", value: "WITH_TAX" }
];

function RequestDetailPrice({ currency, optionsTax })
{
        return (
            <div className="">
                <Field
                    name="priceCurrency"
                    component={SelectField}
                    menuItems={currency}
                />
                <Field
                    component={TextField}
                    name="priceAmount"
                    type="number"
                    validate={[Validation.emptyOrgreaterEqual0]}
                />
                <Field
                    name="withOrWithoutTax"
                    component={SelectField}
                    menuItems={optionsTax}
                />

                <div style={{width: '80%', display: 'inline-block'}}>
                    <Field
                        component={TextField}
                        name="priceTaxAmount"
                        type="number"
                        validate={[Validation.emptyOrgreaterEqual0]}
                    />
                </div>
                <div style={{display: 'inline-block', width: '20%', textAlign: 'center'}}>%</div>
            </div>
        );
}

function RequestDetailEstimatedTime()
{
    return (
        <div className="">
            <Field
                name="days"
                label="Dny"
                component={TextField}
                type="number"
                validate={[Validation.emptyOrgreaterEqual0]}
            />
            <Field
                name="hours"
                label="Hodiny"
                component={TextField}
                type="number"
                validate={[Validation.emptyOrgreaterEqual0]}
            />
            <Field
                name="minutes"
                label="Minuty"
                component={TextField}
                type="number"
                validate={[Validation.emptyOrgreaterEqual0]}
            />
        </div>
    );
}

function NonEditableExtraInformation({ name, value })
{
    return (
        <div className="flex-row">
            <p className="request-label">{name}</p>
            <p>{value}</p>
        </div>
    );
}

function NonEditableInput({ name, value })
{
    // flex-row
    return (
        <div className="touchRequestDetail-nonEditableInput">
            <p className="request-label">{name}</p>
            <p>{value}</p>
            {/*<div className={"touchRequestDetail-nonEditableInput"}>*/}
            {/*</div>*/}
        </div>
    );
}

function RequestDetailEstimatedTime_nextToEachOther()
{
    return (
        <div className="">
            <p className="touchRequestDetail-nonEditableInput request-label">Doba trvání:</p>
            <div className={"flex-row"}>
                <Field
                    name="days"
                    label="Dny"
                    component={TextField}
                    type="number"
                    validate={[ Validation.emptyOrgreaterEqual0 ]}
                />
                <Field
                    name="hours"
                    label="Hodiny"
                    component={TextField}
                    type="number"
                    validate={[ Validation.emptyOrgreaterEqual0 ]}
                />
                <Field
                    name="minutes"
                    label="Minuty"
                    component={TextField}
                    type="number"
                    validate={[ Validation.emptyOrgreaterEqual0 ]}
                />
            </div>
        </div>
    );
}

function RequestDetailPrice_nextToEachOther({ currency, optionsTax })
{
    return (
        <div className="">
            <p className="touchRequestDetail-nonEditableInput request-label">Cena:</p>
            <div className={"flex-row"}>
                <Field
                    name="priceCurrency"
                    component={SelectField}
                    menuItems={currency}
                />
                <Field
                    component={TextField}
                    name="priceAmount"
                    type="number"
                    validate={[ Validation.emptyOrgreaterEqual0 ]}
                />
                <Field
                    name="withOrWithoutTax"
                    component={SelectField}
                    menuItems={optionsTax}
                />
                <Field
                    component={TextField}
                    name="priceTaxAmount"
                    type="number"
                    validate={[ Validation.emptyOrgreaterEqual0 ]}
                />%
            </div>
        </div>
    );
}

function RequestDetailEdit___version2({ handleSubmit, subject, messageBody, sender, user, history, senderName, recipient, optionsProjects, hash, created, modified, type, status, optionsProviderOrganizations, setActiveForm, activeFormData })
{
    return (
        <div className="touchRequestDetail-headerPadding">
            <form onSubmit={handleSubmit} className="margin-bottom">

                <div style={{height: '50px'}}/>

                <div className="">
                    <div className="touchRequestDetail-title">{subject}</div>
                </div>

                <div style={{height: '50px'}}/>

                <div className={"touchRequestDetail-text"}>{messageBody}</div>

                <div style={{height: '50px'}}/>

                <NonEditableInput
                    name={"Požadavek od:"}
                    value={
                        <span
                            className="link"
                            onClick={() =>
                            {
                                if( sender === user.identifier )
                                {
                                    history.push( "/" );
                                }
                                else
                                {
                                    history.push( `/person/${sender}` );
                                }
                            }}
                        >
                                              {`${senderName ? `${senderName} (` : ""}${sender}${senderName
                                                  ? `)`
                                                  : ""}`}
                                            </span>
                    }
                />
                <NonEditableInput
                    name={"Komu:"}
                    value={
                        <span
                            className="link"
                            onClick={() =>
                            {
                                if( recipient.identifier === user.identifier )
                                {
                                    history.push( "/" );
                                }
                                else
                                {
                                    history.push( `/person/${recipient.identifier}` );
                                }
                            }}
                        >
                                              {recipient.name
                                                  ? `${recipient.name} (${recipient.identifier})`
                                                  : recipient.identifier}
                                            </span>
                    }
                />
                <Field
                    name="project"
                    label="Projekt"
                    component={SelectField}
                    menuItems={optionsProjects}
                    validate={[Validation.required]}
                />
                <Field
                    name="customType"
                    label="Typ požadavku"
                    component={SelectField}
                    menuItems={optionsCustomType}
                />
                <NonEditableInput
                    name={"ID požadavku:"}
                    value={hash}
                />
                <NonEditableInput
                    name={"Datum vytvoření:"}
                    value={formatTime( created )}
                />
                <NonEditableInput
                    name={"Datum změny:"}
                    value={formatTime( modified )}
                />
                <Field
                    name="severity"
                    label="Vážnost"
                    component={SelectField}
                    menuItems={optionsSeverity}
                    validate={[Validation.required]}
                />
                <div className="">
                    <p className="touchRequestDetail-nonEditableInput request-label">Cena:</p>
                    <div className={"flex-row"}>
                        <Field
                            name="priceCurrency"
                            component={SelectField}
                            menuItems={currency}
                        />
                        <Field
                            component={TextField}
                            name="priceAmount"
                            type="number"
                            validate={[Validation.emptyOrgreaterEqual0]}
                        />
                        <Field
                            name="withOrWithoutTax"
                            component={SelectField}
                            menuItems={optionsTax}
                        />
                        <Field
                            component={TextField}
                            name="priceTaxAmount"
                            type="number"
                            validate={[Validation.emptyOrgreaterEqual0]}
                        />%
                    </div>
                </div>
                <div className="">
                    <p className="touchRequestDetail-nonEditableInput request-label">Doba trvání:</p>
                    <div className={"flex-row"}>
                        <Field
                            name="days"
                            label="Dny"
                            component={TextField}
                            type="number"
                            validate={[Validation.emptyOrgreaterEqual0]}
                        />
                        <Field
                            name="hours"
                            label="Hodiny"
                            component={TextField}
                            type="number"
                            validate={[Validation.emptyOrgreaterEqual0]}
                        />
                        <Field
                            name="minutes"
                            label="Minuty"
                            component={TextField}
                            type="number"
                            validate={[Validation.emptyOrgreaterEqual0]}
                        />
                    </div>
                </div>

                <div style={{height: '50px'}}/>


                {type === "INVITE_PROVIDER" &&
                status === "INITIAL" && (
                    <Field
                        label="Dodavatel"
                        name="provider"
                        component={SelectField}
                        menuItems={optionsProviderOrganizations}
                        validate={[Validation.required]}
                    />
                )}
                <Field
                    name="comment"
                    label="Komentář ke změně požadavku"
                    component={TextField}
                    rows={5}
                    validate={[Validation.required]}
                />

                <div className="touchButtons-spaceAbove"/>

                <div className="flex-row flex-right">
                    <Button
                        raised
                        className="btn touchButton-5"
                        label="Cancel"
                        onClick={() => setActiveForm( null )}
                    />
                    <div className={"touchButtons-spaceBetween"}/>
                    <Button
                        raised
                        className="btn btn-primary touchButton-6"
                        label={
                            activeFormData && activeFormData.primaryButtonLabel
                                ? activeFormData.primaryButtonLabel
                                : "Save"
                        }
                        type="submit"
                    />
                </div>
            </form>
        </div>
    );
}

function RequestDetailEdit({ handleSubmit, listingValues, optionsProjects, type, status, optionsProviderOrganizations, setActiveForm, activeFormData, created, modified, subject, messageBody, request, getRequestById })
{
    console.log( 'redraw' );
    return (
        <div className="touchRequestDetail-headerPadding">
            <form onSubmit={handleSubmit} className="margin-bottom">

                <div className="">
                    <div className="touchRequestDetail-background2">
                        <TouchVerticalValueRow>

                            <TouchVerticalValue
                                icon={"person"}
                                title={"Od koho:"}
                                value={listingValues.sender}
                                value2={null}
                            />
                            {/*
                                */}
                            <TouchVerticalValue
                                icon={"error"}
                                title={"Důležitost"}
                                value={(
                                    <Field
                                        name="severity"
                                        component={SelectField}
                                        menuItems={optionsSeverity}
                                        validate={[Validation.required]}
                                    />
                                )}
                            />


                            <TouchVerticalValue
                                icon={"attach_money"}
                                title={"Cena"}
                                value={(
                                    <RequestDetailPrice currency={currency} optionsTax={optionsTax}/>
                                )}
                            />


                            <TouchVerticalValue
                                icon={"date_range"}
                                title={"Termín"}
                                value={(
                                    <RequestDetailEstimatedTime/>
                                )}
                            />
                        </TouchVerticalValueRow>
                    </div>

                    <div style={{height: '10px'}}/>

                    <Field
                        name="project"
                        label="Projekt"
                        component={SelectField}
                        menuItems={optionsProjects}
                        validate={[Validation.required]}
                    />

                    <Field
                        name="customType"
                        label="Typ požadavku"
                        component={SelectField}
                        menuItems={optionsCustomType}
                    />

                    <NonEditableExtraInformation name="Datum vytvoření:" value={formatTime( created )}/>
                    <NonEditableExtraInformation name="Datum změny:" value={formatTime( modified )}/>

                </div>

                <div className="">

                    {type === "INVITE_PROVIDER" &&
                    status === "INITIAL" && (
                        <Field
                            label="Dodavatel"
                            name="provider"
                            component={SelectField}
                            menuItems={optionsProviderOrganizations}
                            validate={[Validation.required]}
                        />
                    )}


                    <div style={{height: '26px'}}/>

                    <div className="touchRequestDetail-title">{subject}</div>

                    <div style={{height: '18px'}}/>

                    <div className="touchRequestDetail-text">{messageBody}</div>

                    <div style={{height: '58px'}}/>

                    <RequestDetailInfoAttachments request={request}/>

                    <div style={{height: '58px'}}/>

                    <SideBySide
                        first={
                            <Field
                                name="comment"
                                label="Komentář ke změně požadavku"
                                component={TextField}
                                rows={5}
                                validate={[Validation.required]}
                            />
                        }
                        second={
                            <div style={{ padding: "0 0 0 10%" }} >
                                <TouchUploadButton request={request} getRequestById={getRequestById} />
                            </div>
                        }
                    />
                    <div className="touchButtons-spaceAbove"/>

                    <div className="flex-row flex-right">
                        <Button
                            raised
                            className="btn touchButton-5"
                            label="Cancel"
                            onClick={() => setActiveForm( null )}
                        />
                        <div className={"touchButtons-spaceBetween"}/>
                        <Button
                            raised
                            className="btn btn-primary touchButton-6"
                            label={
                                activeFormData && activeFormData.primaryButtonLabel
                                    ? activeFormData.primaryButtonLabel
                                    : "Save"
                            }
                            type="submit"
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}

function RequestDetailShow({ listingValues, sender, user, history, project, customType, created, modified, priceAmount, priceCurrency, priceTaxAmount, estimatedDuration, initialValues, subject, messageBody, request, type, setActiveForm })
{
    return (
        <div>
            <div className="touchRequestDetail-headerPadding">
                <div className="touchRequestDetail-background2">
                    <TouchVerticalValueRow>

                        <TouchVerticalValue
                            icon={"person"}
                            title={"Od koho:"}
                            value={listingValues.sender}
                            value2={null}
                            onClick={() =>
                            {
                                if( sender === user.identifier )
                                {
                                    history.push( "/" );
                                }
                                else
                                {
                                    history.push( `/person/${sender}` );
                                }
                            }}
                        />

                        <TouchVerticalValue
                            icon={"error"}
                            title={"Důležitost"}
                            valueColor={listingValues.priority.color}
                            value={listingValues.priority.text}
                        />


                        <TouchVerticalValue
                            icon={"attach_money"}
                            title={"Cena"}
                            value={<div className="touchRequestDetail-price">{listingValues.price}</div>}
                        />


                        <TouchVerticalValue
                            icon={"date_range"}
                            title={"Termín"}
                            value={listingValues.deadline}
                        />
                    </TouchVerticalValueRow>
                </div>
            </div>

            <div style={{height: '18px'}}/>

            <div className={"touchRequestDetail-headerPadding"}>

                <NonEditableExtraInformation name="Projekt:" value={project ? project.name : Translate("Žádný projekt")}/>

                {customType && (<NonEditableExtraInformation name="Typ požadavku:" value={customType}/>)}

                <NonEditableExtraInformation name="Datum vytvoření:" value={formatTime( created )}/>
                <NonEditableExtraInformation name="Datum změny:" value={formatTime( modified )}/>

                {priceAmount !== null && (<NonEditableExtraInformation name="Cena:"
                                                                       value={humanFormatPrice( priceAmount, (priceCurrency || "CZK") )}/>)}
                {priceTaxAmount !== null && (<NonEditableExtraInformation name="Daň:"
                                                                          value={humanFormatPrice( priceTaxAmount, (priceCurrency || "CZK") )}/>)}

                {estimatedDuration !== null && (<NonEditableExtraInformation name="Doba trvání:"
                                                                             value={daysHoursMinutesToString( {
                                                                                 days: initialValues.days,
                                                                                 hours: initialValues.hours,
                                                                                 minutes: initialValues.minutes
                                                                             } )}
                />)}

                <div style={{height: '26px'}}/>

                <div className="touchRequestDetail-title">{subject}</div>

                <div style={{height: '18px'}}/>

                <div className="touchRequestDetail-text">{messageBody}</div>

                <div style={{height: '58px'}}/>



                <div style={{height: '26px'}}/>

                {type !== "INVITE_PROVIDER" && (
                    <div style={{textAlign: 'right'}}>
                        <Button
                            flat
                            className="btn btn-primary md-btn md-btn-text touchButton-6 touchButton-shape3"
                            label="Změnit"
                            onClick={() => setActiveForm( "requestContentForm" )}
                        />
                    </div>
                )}
                <div style={{height: '28px'}}/>

            </div>
        </div>
    );
}

const RequestDetailInfo = ( {
  history,
  handleSubmit,
  activeForm,
  setActiveForm,
  initialValues,
  hash,
  project,
  customType,
  created,
  modified,
  sender,
  senderName,
  recipient,
  estimatedDuration,
  projects,
  priceAmount,
  priceCurrency,
  priceTaxAmount,
  subject,
  messageBody,
  activeFormData,
  user,
  type,
  status,
  providerOrganizations,
  request,
  getRequestById
}) => {
  if (!projects) return <div />;

  const optionsProjects = [{ label: "Žádný projekt", value: "NO_PROJECT" }];

  forEach(projects.item, item =>
    optionsProjects.push({ label: item.name, value: item.identifier })
  );

  const optionsProviderOrganizations = [];
  
  forEach(providerOrganizations, item =>
    optionsProviderOrganizations.push({ label: item.name, value: item.identifier })
  );

  let listingValues = {};
  {
      listingValues.sender = senderName;

      if( priceAmount && priceCurrency )
      {
          listingValues.price = humanFormatPrice( priceAmount, priceCurrency )
      }

      listingValues.priority = {};
      {
          let priorityItem = find( optionsSeverity,  o => o.value === initialValues.severity );
          if( priorityItem )
          {
              listingValues.priority.text = priorityItem.label;
              listingValues.priority.color =  priorityItem.color;
          }
      }

      if( estimatedDuration )
      {
          // listingValues.deadline = ' [estimated] ';
          listingValues.deadline = daysHoursMinutesToString({
            days: initialValues.days,
            hours: initialValues.hours,
            minutes: initialValues.minutes
        });
      }
      else
      {
        listingValues.deadline = '';
      }
  }

  return (
    <div>
      <DebugElement text={"src/components/request/RequestDetailInfo.js"}/>
        <div className="flex-col">

            {/* <RequestDetailEdit___version2  {...{ /> */}

          {activeForm === "requestContentForm" ? (
              <RequestDetailEdit {...{ handleSubmit, listingValues, optionsProjects, type, status, optionsProviderOrganizations, setActiveForm, activeFormData, created, modified, subject, messageBody }} request={request} getRequestById={getRequestById} />
          ) : (
            <div>

              <RequestDetailShow {...{ listingValues, sender, user, history, project, customType, created, modified, priceAmount, priceCurrency, priceTaxAmount, estimatedDuration, initialValues, subject, messageBody, request, type, setActiveForm }} />

            </div>
          )}
        </div>
    </div>
  );
};

export default compose(
  connect(
    ({ app: { form: { activeForm, activeFormData } } }) => ({
      activeForm,
      activeFormData
    }),
    {
      setActiveForm,
      getRequestById,
      updateRequest
    }
  ),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {

        /*

            RequestModel.update( formModel or formData ... )
                {
                    form get data
                    validate if all data is there ===> validace, oprava !!!
                    put request
                }
            if( RequestModel.getUpdateErrors())
            {
                log errors
                throw some bullshit for react form
            }
            else
            {
                setactiveform
            }


            ZAVISLOSTI:

                - redux form
                - tvar formData

        */
      const {
        request,
        getRequestById,
        setActiveForm,
        updateRequest,
        activeFormData
      } = props;
      const {
        customType,
        priceAmount,
        priceCurrency,
        priceTaxAmount,
        project,
        days,
        hours,
        minutes,
        withOrWithoutTax,
        severity,
        comment,
        provider
      } = formData;

      if (
        (request.priceAmount || request.priceTaxAmount) &&
        (!priceAmount || priceAmount === "")
      ) {
        throw new SubmissionError({
          priceAmount: "Vyplňte cenu"
        });
      }

      if (
        (request.priceAmount || request.priceTaxAmount) &&
        (!priceTaxAmount || priceTaxAmount === "")
      ) {
        throw new SubmissionError({
          priceTaxAmount: "Vyplňte daň"
        });
      }

      const userEnteredAnyDurationEstimation = ( days || hours || minutes );

      log('estimation', { wtfValue: !! (!days ||
          days === "" ||
          !hours ||
          hours === "" ||
          !minutes ||
          minutes === "")
        , userEnteredAnyDurationEstimation
      });
      if ( request.estimatedDuration !== null && ! userEnteredAnyDurationEstimation )
      {
        throw new SubmissionError({
          days: "Vyplňte předpokládanou dobu trvání"
        });
      }

      const estimatedDuration =
        (days && days !== "" ? Number(days) * 24 * 60 : 0) +
        (hours && hours !== "" ? Number(hours) * 60 : 0) +
        (minutes && minutes !== "" ? Number(minutes) : 0);

      const requestForUpdate = {
        ...request,
        customType,
        estimatedDuration:
          !estimatedDuration || estimatedDuration === 0
            ? null
            : estimatedDuration,
        priceAmount: priceTaxAmount
          ? withOrWithoutTax === "WITHOUT_TAX"
            ? priceAmount
            : priceAmount / (priceTaxAmount / 100 + 1)
          : null,
        priceCurrency: !priceAmount || !priceTaxAmount ? null : priceCurrency,
        priceTaxAmount: priceAmount
          ? withOrWithoutTax === "WITHOUT_TAX"
            ? priceTaxAmount
            : priceAmount - priceAmount / (priceTaxAmount / 100 + 1)
          : null,
        project:
          project && project !== "NO_PROJECT" ? { identifier: project } : null,
        severity,
        comment,
        customFields:
          request.type === "INVITE_PROVIDER" && request.status === "INITIAL"
            ? !isEmpty(request.customFields)
              ? [...request.customFields, { name: "provider", value: provider }]
              : [{ name: "provider", value: provider }]
            : request.customFields
      };

      log( 'sending message', { request, formData, customType, requestForUpdate, activeFormData  });

      debugger;

      const response = activeFormData
        ? await updateRequest({ ...requestForUpdate, ...activeFormData.formData })
        : await updateRequest(requestForUpdate);

      if (response) {
        setActiveForm(null);
        console.log({ 'request.hash': request.hash, request, response });
        await getRequestById(request.hash);
      } else
        throw new SubmissionError({
          comment: "Požadavek se nepodařilo aktualizovat."
        });
    }
  }),
  lifecycle({
    componentWillUnmount() {
      const { setActiveForm } = this.props;
      setActiveForm(null);
    }
  }),
  reduxForm({ form: "requestContentForm", enableReinitialize: true })
)(RequestDetailInfo);



// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestDetailInfo.js